import { createSlice } from '@reduxjs/toolkit';

const usersSlice = createSlice({
	name: 'users',
	initialState: {
		loading: false,
		loadingUserSelected: false,
		users: [],
		students: [],
		userSelected: {},
	},
	reducers: {
		getAllUsersStart: (state) => {
			state.loading = true;
		},
		getAllUsersSucSuccess: (state, { payload: { data } }) => {
			state.loading = false;
            state.users = data;
		},
		getAllUsersFailure: (state) => {
			state.loading = false;
		},
		getAllStudentsStart: (state) => {
			state.loading = true;
		},
		getAllStudentsSucSuccess: (state, { payload: { students } }) => {
			state.loading = false;
            state.students = students;
		},
		getAllStudentsFailure: (state) => {
			state.loading = false;
		},
		getAllUserByIdStart: (state) => {
			state.loadingUserSelected = true;
		},
		getAllUserByIdSucSuccess: (state, { payload: { user } }) => {
			state.loadingUserSelected = false;
			
			// Si ya hay un usuario seleccionado y tiene records, concatenar los nuevos
			if (state.userSelected?._id === user._id && state.userSelected?.records && user.recordsMetadata?.page > 1) {
				state.userSelected = {
					...user,
					records: [...state.userSelected.records, ...user.records]
				};
			} else {
				// Si es un usuario nuevo o la primera página, reemplazar todo
				state.userSelected = user;
			}
		},
		getAllUserByIdFailure: (state) => {
			state.loadingUserSelected = false;
		},
	},
});

export const {
	getAllUsersStart,
	getAllUsersSucSuccess,
	getAllUsersFailure,
	getAllStudentsStart,
	getAllStudentsSucSuccess,
	getAllStudentsFailure,
	getAllUserByIdStart,
	getAllUserByIdSucSuccess,
	getAllUserByIdFailure,
} = usersSlice.actions;
export default usersSlice.reducer;